<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <h1 class="navbar-item">
        <router-link to="/">Vonder</router-link>
      </h1>
      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="main-menu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="main-menu" class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item">
          <div v-if="currentUser" class="buttons">
            <b-button tag="router-link" to="/">@{{ currentUser.username }}</b-button>
            <b-button tag="router-link" :to="{ name: 'post.new' }">New Post</b-button>
          </div>
          <div v-else class="buttons">
            <a class="button is-primary">
              <strong>Sign up</strong>
            </a>
            <a class="button is-light">
              Log in
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {}
</script>

<style>
.navbar {
  border-bottom: 1px solid #408242;
  margin-bottom: 2em;
}
.navbar-brand h1 {
  font-weight: bold;
  font-size: 2em;
}
</style>
